import { adminRequests } from 'api/request';
import urls from 'configs/urls';

export const updateCompanyLicenceStatus = ({ data, companyProfileKey }) =>
  adminRequests.patch(
    null,
    false,
    `${urls.companyActivationUrls.updateCompanyLicenceStatus(companyProfileKey)}`,
    data,
  );
